import Axios from "axios";
import { $observable } from "../../common/libs/AxiosObservable";

export const getAnalytics = () => {
  return $observable(Axios.get("/api/v1/admin/dashboard/analytics"));
};
